import { render, staticRenderFns } from "./PomodoroReviewCard.vue?vue&type=template&id=89367fa8&scoped=true&"
import script from "./PomodoroReviewCard.vue?vue&type=script&lang=js&"
export * from "./PomodoroReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./PomodoroReviewCard.vue?vue&type=style&index=0&id=89367fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89367fa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol})
